<template>
  <div class="diaglog-wrapper">
    <div class="dialog-container order-detail-dialog">
      <div class="order-detail-dialog-container">
        <p class="title">{{ letter.order_detail }}</p>
        <div class="detail">
          <div
            class="detail-item"
            v-for="(item, index) in cartList"
            :key="index"
          >
            <div class="name">{{ item.productDesc }}</div>
            <div class="num">
              {{ letter.total_detail
              }}<span class="num-quantity">{{ item.quantity }}</span>
            </div>
            <div class="total-wrap">
              <span class="total"> {{ letter.storeTotal }}：</span>
              {{ itemTotalPrice(+item.amount, +item.quantity) }}
              {{ currency }}
            </div>
          </div>
          <div class="detail-item">
            <div class="name extra">{{ letter.storeExtra }}:</div>
            <div class="total-wrap extra">
              <span class="num">{{ totalExtra }}</span
              >{{ coinName }}
            </div>
          </div>
        </div>
      </div>
      <button
        class="close-btn j-click-close-cart-detail-popup"
        @click="close"
      ></button>
    </div>
  </div>
</template>
<script>
import { times } from '@utiles/officialStore/index';
export default {
  props: ['cartList', 'currency', 'coinName'],
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    totalExtra() {
      let totalExtra = 0;
      this.cartList.forEach(item => {
        totalExtra += +item.extraCoin;
      });
      return totalExtra;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    itemTotalPrice(amount, quantity) {
      return times(+amount, +quantity);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
@import '@assets/scss/officialStore/common.scss';
.order-detail-dialog {
  padding: 0;
  background-size: cover;
  @psetbg ('detail-popup.png');
}
.order-detail-dialog-container {
  width: 100%;
  height: 100%;
}
.title {
  margin: 43px auto 32px;
  text-align: center;
  font-weight: bolder;
  font-size: 48px;
  color: var(--result-order-popup-title);
}
.detail {
  overflow: -moz-scrollbars-none;
  overflow-y: scroll;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 32px;
  background-size: cover;
  font-size: 24px;
  color: #e1e1e1;

  -ms-overflow-style: none;
  scrollbar-width: none;
  @psetbg ('order-detail-content-bg.png');
  &-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px 0;
    border-bottom: 1px solid #666;
    .name {
      color: var(--result-order-popup-item-name);
      &.extra {
        color: var(--result-order-popup-item-extra);
      }
    }
    .num {
      margin: 8px 0;
      color: var(--result-order-popup-item-num-name);
      &-quantity {
        color: var(--result-order-popup-item-num);
      }
    }
    .total-wrap {
      font-weight: bold;
      color: var(--result-order-popup-item-price);
      .total {
        color: var(--result-order-popup-item-total);
      }
      &.extra {
        color: var(--result-order-popup-item-extra-price);
        .num {
          font-size: 34px;
        }
      }
    }
  }
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
}
.close-btn {
  position: absolute;
  right: 46px;
  top: 36px;
  @psetbg ('close.png');
}
@media screen and (orientation: landscape) {
  .order-detail-dialog {
    background-size: cover;
    @psetbg ('detail-popup-hen.png');
  }
  .title {
    margin: 53px auto 20px;
    font-size: 30px;
  }
  .detail {
    padding: 0 32px;
    font-size: 16px;
    @psetbg ('order-detail-content-bg-hen.png');
  }
  .close-btn {
    right: 31px;
    top: 23px;
    cursor: pointer;
    @psetbg ('close-hen.png');
  }
}
</style>
